import { Injectable } from "@angular/core";

import { ApiService } from "./api.service";
import { lastValueFrom, Subject } from "rxjs";
import { BehaviorSubject } from "rxjs";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { LocalNotifications } from "@capacitor/local-notifications";
import {
  PushNotifications,
  Token,
  ActionPerformed,
  PushNotificationSchema,
} from "@capacitor/push-notifications";
import { Preferences } from "@capacitor/preferences";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import * as moment from "moment";

@Injectable({
  providedIn: "root",
})
export class PushNotificationsService {
  id: any;
  tryOuts;
  public token = "";
  private user: any = {};
  notificationReceived: Subject<any> = new BehaviorSubject<any>({});
  constructor(
    private api: ApiService,
    private afDb: AngularFirestore,
    private afAuth: AngularFireAuth
  ) {
    this.afAuth.onAuthStateChanged(async (user) => {
      if (user) {
        this.id = user.uid;
        this.user = user;
        this.setDevice();
      }
    });
  }

  start() {
    this.setPushToken();
    this.setDevice();
    PushNotifications.addListener("registration", async (token: Token) => {
      Preferences.set({ key: "pushNotificationToken", value: token.value });
      this.token = token.value;
      this.registerToTopic("all");
      if (this.tryOuts) {
        clearInterval(this.tryOuts);
      }
    });

    PushNotifications.addListener("registrationError", (error: any) => {
      if (!this.tryOuts) {
        this.tryOuts = setInterval(() => {
          this.setPushToken();
        }, 60000);
      }
    });

    PushNotifications.addListener(
      "pushNotificationReceived",
      (notification: PushNotificationSchema) => {}
    );

    PushNotifications.addListener(
      "pushNotificationActionPerformed",
      (notification: ActionPerformed) => {
        if (!!notification) {
          this.notificationReceived.next(notification);
        }
      }
    );
  }

  async setTopics() {
    const observable = this.afDb.collection("profiles").doc(this.id).get();
    const user: any = (await lastValueFrom(observable)).data();
    if (user.member == true) {
      this.registerToTopic("onlyMember");
    }
    if (!user.notResident) {
      this.registerToTopic("onlyVenezuela");
    }

    if (user.member == true && !user.notResident) {
      this.registerToTopic("onlyMembersVenezuela");
    }
  }

  setPushToken() {
    PushNotifications.register();
  }
  async setDevice() {
    if (!!this.user && !!this.token) {
      try {
        await this.afDb.collection("devices").doc(this.token).set({
          userId: this.user.uid,
          token: this.token,
          createdAt: moment().unix(),
        });
        this.setTopics();
      } catch (err) {
        console.log(err);
      }
    }
  }
  registerToTopic(topic: string) {
    this.api.post("registerToTopic", { token: this.token, topic });
  }
  createLocal(data) {
    LocalNotifications.schedule(data);
  }
}

